import HousingCorporationsListPage from '$src/housingCorporations/HousingCorporationsListPage'
import NotFoundPage from './NotFoundPage'
import * as React from 'react'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'

import SplashUnlessBootstrapped from './SplashUnlessBootstrapped'
import RedirectFromIndex from './RedirectFromIndex'
import LoggedOutOnlyRoute from '$src/bootstrap/routing/LoggedOutOnlyRoute'
import LoginPage from '$src/auth/LoginPage/LoginPage'
import ProjectsPage from '$src/projects/ProjectsPage'
import LoggedInOnlyRoute from '$src/bootstrap/routing/LoggedInOnlyRoute'
import {hot} from 'react-hot-loader'
import ComparableSalesPage from '$src/comparableSales/ComparableSalesPage'
import Errors from '$src/bootstrap/Errors/Errors'
import LogoutPage from '$src/auth/LogoutPage'

const RootRoutes = () => {
  return (
    <>
      <SplashUnlessBootstrapped>
        <Errors />
        <Router>
          <Switch>
            <LoggedOutOnlyRoute
              key="home"
              path={`/login`}
              component={LoginPage}
            />
            <LoggedInOnlyRoute
              path={'/projects'}
              exact
              component={ProjectsPage}
            />
            <LoggedInOnlyRoute
              path={'/housing-corporations-list/:id/:name'}
              exact
              component={HousingCorporationsListPage}
            />
            <LoggedInOnlyRoute
              path={
                '/comparable-sales-list/:projectId/:projectName/:housingCorporationId'
              }
              exact
              component={ComparableSalesPage}
            />
            <LoggedInOnlyRoute
              path={
                '/comparable-sales-list/:projectId/:projectName/:housingCorporationId/:tabId'
              }
              exact
              component={ComparableSalesPage}
            />
            <LoggedInOnlyRoute exact path="/logout" component={LogoutPage} />
            <Route
              key="toIndex"
              path={`/`}
              exact
              component={RedirectFromIndex}
            />
            <Route key="404" component={NotFoundPage} />,
          </Switch>
        </Router>
      </SplashUnlessBootstrapped>
    </>
  )
}

export default hot(module)(RootRoutes)



// WEBPACK FOOTER //
// ./src/bootstrap/routing/RootRoutes.tsx